import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import ReactHtml from 'raw-html-react';
class Blogleftbar extends React.Component {
    render() {
return<div>
                        <div class="common-sidebar-widget">
                            <h3 class="sidebar-title">Search</h3>
                            <div class="sidebar-search">
                                <form action="#">
                                    <input type="text" placeholder="Search"/>
                                    <button><i class="fa fa-search"></i></button>
                                </form>
                            </div>
                        </div>
                     {/*    <!-- Single Sidebar End  -->
                        <!-- Single Sidebar Start  --> */}
                        <div class="common-sidebar-widget">
                            <h3 class="sidebar-title">Recent posts</h3>
                            <div class="sidebar-blog">
                                <a href="blog-details.html" class="image"><img src="./assets/images/rc-post/blog1.jpg" alt=""/></a>
                                <div class="content">
                                    <h5><a href="blog-details.html">Blog image post (sticky)</a></h5>
                                    <span>April 24, 2018</span>
                                </div>
                            </div>
                            <div class="sidebar-blog">
                                <a href="blog-details.html" class="image"><img src="./assets/images/rc-post/blog2.jpg" alt=""/></a>
                                <div class="content">
                                    <h5><a href="blog-details.html">Post with Gallery</a></h5>
                                    <span>April 24, 2018</span>
                                </div>
                            </div>
                            <div class="sidebar-blog">
                                <a href="blog-details.html" class="image"><img src="./assets/images/rc-post/blog3.jpg" alt=""/></a>
                                <div class="content">
                                    <h5><a href="blog-details.html">Post with Audio</a></h5>
                                    <span>April 24, 2018</span>
                                </div>
                            </div>
                            <div class="sidebar-blog">
                                <a href="blog-details.html" class="image"><img src="./assets/images/rc-post/blog4.jpg" alt=""/></a>
                                <div class="content">
                                    <h5><a href="blog-details.html">Post with Video</a></h5>
                                    <span>April 24, 2018</span>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Single Sidebar End  -->
                        <!-- Single Sidebar Start  --> */}
                        <div class="common-sidebar-widget">
                            <h3 class="sidebar-title">Recent comments</h3>
                            <div class="sidebar-blog">
                                <div class="image"><img src="assets/images/icons/author.png" alt=""/></div>
                                <div class="content">
                                    <p>admin says:</p>
                                    <a href="#">Nulla auctor mi vel nisl...</a>
                                </div>
                            </div>
                            <div class="sidebar-blog">
                                <div class="image"><img src="assets/images/icons/author.png" alt=""/></div>
                                <div class="content">
                                    <p>admin says:</p>
                                    <a href="#">Nulla auctor mi vel nisl...</a>
                                </div>
                            </div>
                            <div class="sidebar-blog">
                                <div class="image"><img src="assets/images/icons/author.png" alt=""/></div>
                                <div class="content">
                                    <p>admin says:</p>
                                    <a href="#">Nulla auctor mi vel nisl...</a>
                                </div>
                            </div>
                            <div class="sidebar-blog">
                                <div class="image"><img src="assets/images/icons/author.png" alt=""/></div>
                                <div class="content">
                                    <p>admin says:</p>
                                    <a href="#">Nulla auctor mi vel nisl...</a>
                                </div>
                            </div>
                        </div>
                      {/*   <!-- Single Sidebar End  -->
                        <!-- Single Sidebar Start  --> */}
                        <div class="common-sidebar-widget">
                            <h3 class="sidebar-title">Categories</h3>
                            <ul class="sidebar-list">
                                <li><a href="#"><i class="ion-plus"></i>Accessories <span class="count">(14)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Decor <span class="count">(14)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Furniture <span class="count">(28)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Lighting <span class="count">(14)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Outdoor <span class="count">(14)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Sports <span class="count">(13)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Storage <span class="count">(9)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Toys <span class="count">(9)</span></a></li>
                                <li><a href="#"><i class="ion-plus"></i>Uncategorized <span class="count">(0)</span></a></li>
                            </ul>
                        </div>
                        {/* <!-- Single Sidebar End  -->
                        <!-- Single Sidebar Start  --> */}
                        <div class="common-sidebar-widget">
                            <h3 class="sidebar-title bb-0">Tags</h3>
                            <ul class="sidebar-tag">
                                <li><a href="#">Painting</a></li>
                                <li><a href="#">Plumbing</a></li>
                                <li><a href="#">Flooring</a></li>
                                <li><a href="#">Roofing</a></li>
                                <li><a href="#">Tools</a></li>
                                <li><a href="#">Electrical</a></li>
                            </ul>
                        </div>
                        
</div>

}
}
export default Blogleftbar;